export const Urlconstant = {
  // Production
  ELASTIC_API:
    "DE475386C9BB2A5AC53F7EE2029B5F7A9917FDD6FE1F9722111399AF84419AEC47C13D20C6EA655A1320E5A85DA3FEBD",
  url: "https://x-workz.in:8443/dream/",
  BACTH_URL: "https://x-workz.in:8443/attendance-batch/",
  FEEDBACK_URL: "https://x-workz.in:8443/feedback-mock/",
  spreadsheetId: "1HI3nKYRbXNl2cu9rKwqKp3tznOZ7ziOupokU_daFZ8E",

  //pre-Production/
  // ELASTIC_API:""
  //url: "http://122.166.169.126:8083/dream-pre/",
  //  BACTH_URL: "http://122.166.169.126:8083/attendance-batch-pre/",
  //  FEEDBACK_URL: "http://122.166.169.126:8083/feedback-mock-pre/",
  //  spreadsheetId: "1BBvpbYuTvqaXQ2ooVItm0MGqB5XMnNgpHc0ZUW4zqLg"

  //  dev
  // ELASTIC_API:""
  // url: "http://122.166.169.126:8084/dream-dev/",
  // BACTH_URL: "http://122.166.169.126:8084/attendance-batch-dev/",
  // FEEDBACK_URL: "http://122.166.169.126:8084/feedback-mock-dev/",
  // spreadsheetId: "1NrTU01N_mU-HnPIQjPOzQhf_7CEXH430RzJb6wdDJ-Q"

  //local
  // ELASTIC_API:""
  // url: "http://localhost:8081/",
  // BACTH_URL: "http://localhost:8084/",
  // FEEDBACK_URL: "http://localhost:8085/",
  // spreadsheetId: "1NrTU01N_mU-HnPIQjPOzQhf_7CEXH430RzJb6wdDJ-Q",
};
